const agenceAnim = {
  isMobileOrTablet() {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      ) || navigator.maxTouchPoints > 2
    );
  },

  init() {
    document.addEventListener("DOMContentLoaded", () => {
      const cursor = document.querySelector(".blob-agence");
      const hash = window.location.hash;

      // 1. Bloquer le scroll natif vers l'ancre SANS toucher la position
      history.scrollRestoration = "manual";

      /* GSAP ANIMATIONS */
      //Smooth content
      let smoother = ScrollSmoother.create({
        wrapper: "#smooth-container",
        content: "#smooth-content",
        smooth: 0.7,
        effects: false,
      });
      window.dispatchEvent(new Event("scrollSmootherReady"));

      // Register ScrollTrigger and refresh after ScrollSmoother is created
      gsap.registerPlugin(ScrollTrigger);
      ScrollTrigger.refresh();


      if (window.location.hash) {
        const id = window.location.hash.slice(1);
        const target = document.getElementById(id);
        if (target) {
          const smoother = ScrollSmoother.get();
          if (smoother) {
            smoother.scrollTo(target, true, "center top");
          } else {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      }

      /* CURSOR */

      // N'appliquer les effets du curseur que si ce n'est pas un mobile/tablette
      if (!this.isMobileOrTablet()) {
        // 2. Suivi de la souris avec throttle à 60fps (~16.67ms)
        const root = document.documentElement;
        const smoothContent = document.querySelector("#smooth-content");
        let mx = -9999,
          my = -9999,
          rafId = 0,
          lastUpdateTime = 0;
        const THROTTLE_INTERVAL = 1000 / 60; // ~16.67ms pour 60fps

        function apply() {
          // Mettre à jour les variables CSS pour tous les éléments .glow-border
          const glowBorders = document.querySelectorAll(".glow-border");

          glowBorders.forEach((element) => {
            element.style.setProperty(
              "--mx",
              mx - element.getBoundingClientRect().left,
            );
            element.style.setProperty(
              "--my",
              my - element.getBoundingClientRect().top,
            );
          });

          // Mettre à jour le cursor blob avec les coordonnées correctes
          if (cursor) {
            // Récupérer le décalage Y du smooth-content
            const scrollOffset = gsap.getProperty("#smooth-content", "y") || 0;
            gsap.to(cursor, {
              x: mx - 25,
              y: my - 25 - scrollOffset,
              duration: 0,
              overwrite: false,
            });
          }

          rafId = 0;
          lastUpdateTime = performance.now();
        }

        function move(e) {
          // Utilise les coordonnées de la souris par rapport au viewport
          mx = e.clientX;
          my = e.clientY;
          const now = performance.now();
          if (!rafId && now - lastUpdateTime >= THROTTLE_INTERVAL) {
            rafId = requestAnimationFrame(apply);
          }
        }

        function leave() {
          mx = -9999;
          my = -9999;
          const now = performance.now();
          if (!rafId && now - lastUpdateTime >= THROTTLE_INTERVAL) {
            rafId = requestAnimationFrame(apply);
          }
        }

        // Écoute sur window pour éviter les problèmes de capture d'événements
        window.addEventListener("pointermove", move, { passive: true });
        window.addEventListener("pointerleave", leave, { passive: true });
      }

      gsap.to(".side2", {
        color: "#58eea1",
        duration: 2,
        ease: "power1.inOut",
      });

      /* GALLERY 1 */
      const items = document.querySelectorAll(".gallery-item");
      const gallery = document.querySelector(".presentation-gallery");
      const numItems = items.length;

      // Sur mobile/tablette, utiliser le scroll natif
      if (this.isMobileOrTablet()) {
        // Aucune animation GSAP, le scroll natif suffit
      } else {
        // Animation GSAP pour desktop uniquement
        // Calculer la hauteur selon le nombre d'images
        // Height = (Width / numItems) * (3/2) pour garder le ratio 2/3
        const containerWidth = gallery.offsetWidth;
        const itemHeight = (containerWidth / numItems) * (3 / 2);
        const itemWidth = itemHeight * (2 / 3);

        gallery.style.height = itemHeight + "px";

        items.forEach((item, index) => {
          gsap.to(item, {
            scrollTrigger: {
              trigger: ".presentation-gallery",
              start: "0% 80%",
              end: "bottom center",
              scrub: 1,
              markers: false,
            },
            x: -(index * itemWidth),
            opacity: 1,
            duration: 1,
            delay: index * 0.05,
            ease: "power2.out",
          });
        });
      }

      /* PANEL */

      gsap.utils.toArray(".skill-panel").forEach((panel, i) => {
        ScrollTrigger.create({
          trigger: panel,
          start: "top top",
          pin: true,
          pinSpacing: false,
          markers: false,
          endTrigger: ".origins",
          end: "top bottom",
        });
      });

      /* ORIGINS */
      if (!this.isMobileOrTablet()) {
        gsap.to(".origins-image", {
          scrollTrigger: {
            trigger: ".origins",
            start: "0% 80%",
            /* end: "top center", */
            scrub: 1,
            markers: false,
          },
          y: -250,
        });
      }

      /* TITRE HUMAINE */

      gsap.from("#humaine path", {
        scrollTrigger: {
          trigger: "#humaine",
          start: "0% 80%",
          markers: false,
        },
        duration: 0.2,
        drawSVG: 0,
        stagger: 0.2,
      });

      /* const tl = gsap
        .timeline({
          repeat: -1,
          defaults: { duration: 3, ease: "power1.inOut" },
        })
        .set(".draw", { opacity: 1 })
        .from("path", { drawSVG: "0% 0%" })
        .to("path", { drawSVG: "100% 100%" }); */
    });

    /* TEAM MARQUEE */

    const marquee = document.querySelector(".marquee");
    const inner = document.querySelector(".marquee-wrap");
    const content = document.querySelector(".marquee-text");

    inner.append(content.cloneNode(true));

    const animations = [];
    inner.querySelectorAll(".marquee-text").forEach((element) => {
      const animation = gsap.to(element, {
        x: "-100%",
        repeat: -1,
        duration: 30,
        ease: "linear",
      });
      animations.push(animation);
    });

    marquee.addEventListener("mouseenter", () => {
      animations.forEach((anim) => anim.pause());
    });

    marquee.addEventListener("mouseleave", () => {
      animations.forEach((anim) => anim.play());
    });

    // SCROLL TO TOP BUTTON
    const scrollToTopBtn = document.getElementById("scroll-to-top");
    if (scrollToTopBtn) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 300) {
          scrollToTopBtn.classList.add("visible");
        } else {
          scrollToTopBtn.classList.remove("visible");
        }
      });

      scrollToTopBtn.addEventListener("click", () => {
        ScrollSmoother.get().scrollTo(0, true);
      });
    }
    /* const tl = gsap.timeline();
for (let i = 0; i < 8; i++) {
  const intensity = 12 * (1 - i / 8);
  tl.to(".text", {
    x: gsap.utils.random(-intensity, intensity),
    y: gsap.utils.random(-intensity * 0.5, intensity * 0.5),
    rotation: gsap.utils.random(-3, 3),
    duration: 0.05
  });
}
tl.to(".text", { x: 0, y: 0, rotation: 0, duration: 0.3 }); */
  },
};

export default agenceAnim;
